import axiosInstance from "../axiosInterceptor";

export async function getBonusByID(body) {
  const response = await axiosInstance.post(`admin/bonuses/getBonusByID`, body);
  const data = response?.data;
  return data;
}
